
import { Vue, Component, Model, Prop, Emit } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import Util from '../../../bower_components/teknisavuecomponents/assets/utils/Util'

interface Action {
  name: string;
  label: string;
  executeAction: Function;
  cssClass?: string;
  color?: string;
  actionKey?: string;
  icon?: string;
  executeWhenKeyboardInputIsFocused?: boolean;
  forceNotDisabled?: boolean;
}

@Component({
  name: 'RegistroPontoUnidadeNumericKeyboard',
})
export default class RegistroPontoUnidadeNumericKeyboard extends Vue {
  @Model('changeKeyboardInput')
  private keyboardInput;

  @Prop()
  private visibility: boolean;

  @Prop({ default: () => [] })
  private actions: Action[];

  @Getter('loadingVisibility')
  private loadingVisibility: boolean;

  private defaultButtonClasses: string[] = [
    'text-capitalize',
  ];

  private defaultActions: Action[] = [
    {
      name: 'Cancel',
      label: '',
      executeAction: this.actionCancel,
      actionKey: 'Backspace',
      icon: 'backspace',
      executeWhenKeyboardInputIsFocused: false,
    },
    {
      name: 'fullscreen',
      label: '',
      executeAction: this.toggleFullScreen,
      icon: 'fullscreen',
      forceNotDisabled: true,
    },
  ]

  private keyboardViewFocused = false;

  private prefixes = {
    keyboardButton: '.keyboard__button--',
  };

  private get getDefaultButtonClasses() {
    return Array.isArray(this.defaultButtonClasses) && this.defaultButtonClasses.length > 0 ? this.defaultButtonClasses.join(' ') : '';
  }

  private get isKeyboardAvailable() {
    return this.visibility && !this.loadingVisibility;
  }

  private created() {
    document.onkeydown = this.handleKeyboardInput;
    Util.addFullScreenChangeListener(this.updateActionFullScreenIcon);
    this.addDefaultActions();
  }

  private destroyed() {
    document.onkeydown = () => null;
  }

  private addDefaultActions() {
    for (const defaultAction of this.defaultActions) {
      let actionsWithSameName = this.actions.filter((action) => action.name === defaultAction.name);
      let actionNotExist = actionsWithSameName.length === 0;
      if (actionNotExist) {
        this.actions.push(defaultAction);
      }
    }
  }

  private handleKeyboardInput(evt: KeyboardEvent) {
    const keyboardItemBaseClass = 'keyboard__button--1';
    const keyPressed = evt.key;
    const numericKey = parseInt(keyPressed, 10);

    if (this.isKeyboardAvailable) {
      if (Number.isInteger(numericKey) && !this.keyboardViewFocused) {
        const button = this.getButtonElementByNumber(numericKey);
        button.click();
      } else {
        const actionToExecute = this.actions.find((action) => action.actionKey === keyPressed);
        
        // Verifica se há ação a ser excutada e se a ação considera ou não se o input do teclado está focado.
        if (actionToExecute && actionToExecute.executeAction &&
          !(!Util.isUndefinedOrNull(actionToExecute.executeWhenKeyboardInputIsFocused) && !actionToExecute.executeWhenKeyboardInputIsFocused && this.keyboardViewFocused)
        ) {
          actionToExecute.executeAction(this.keyboardInput);
        }
      }
    }

  }
  
  @Emit('changeKeyboardInput')
  private numericClickHandler(keyboardInput: number) {
    const keyboardInputNormalized: string = this.normalizeButtonNumber(keyboardInput);
    let numbersTyped = this.keyboardInput;
    if (numbersTyped === null) {
      numbersTyped = '';
    }
    numbersTyped += keyboardInputNormalized;
    return numbersTyped;
  }

  private actionClickHandler(actionName: string) {
    const availableAction: Action = this.actions.find(
      (action: any) => action.name === actionName);

    if (availableAction) {
      availableAction.executeAction(this.keyboardInput);
    }
  }

  @Emit('changeKeyboardInput')
  private updateKeyboardViewValue(value) {
    return value;
  }

  private setKeyboardViewFocused(focus: boolean) {
    this.keyboardViewFocused = focus;
  }

  @Emit('changeKeyboardInput')
  private actionCancel() {
    return this.keyboardInput ? this.keyboardInput.substring(0, this.keyboardInput.length - 1) : '';
  }

  @Emit('click:fullscreen')
  private toggleFullScreen() {
    this.updateActionFullScreenIcon();
  }

  private updateActionFullScreenIcon() {
    const action = this.actions.find(a => a.name == 'fullscreen');
    if (!action) {
      return
    }

    action.icon =
      Util.isInFullScreen() ? 'fullscreen' : 'fullscreen_exit';
  }

  private actionColor(action: Action) {
    return action.color ? `background-color: ${action.color} !important` : '';
  }

  private actionClass(action: Action) {
    return `keyboard__item keyboard__action keyboard__action--${action.name} ${action.cssClass ? action.cssClass : ''} ${this.getDefaultButtonClasses}`;
  }

  private buttonClass(buttonNumber: number) {
    return `keyboard__item keyboard__button--${buttonNumber === 10 ? 0 : buttonNumber}`;
  }

  private normalizeButtonNumber(buttonNumber: number) {
    return (buttonNumber === 10 ? 0 : buttonNumber).toString();
  }

  private getButtonElementByNumber(number: number): HTMLElement {
    return document.querySelector(`${this.prefixes.keyboardButton}${number}`);
  }

}

